import { AppStateSlice } from '../../stores/app_state';
import { startWakeWord, stopWakeWord } from '../../wake-word/useWakeWord';
import { SpeechStore } from './types';

export const createSpeechStore: AppStateSlice<SpeechStore> = (set, get) => ({
  listening_to_voice: false,
  wake_word_enabled: true,
  setWakeWordEnabled(wake_word_enabled) {
    set({ wake_word_enabled });

    if (wake_word_enabled) {
      startWakeWord();
    } else {
      stopWakeWord();
    }
  },
  startWakeWordListening() {
    if (get().wake_word_enabled) {
      startWakeWord();
    }
  },
  startListeningToVoice() {
    set({ listening_to_voice: true });
  },
  stopListeningToVoice() {
    set({ listening_to_voice: false });
  },
});
